import React from 'react';
import { useLocation } from 'react-router-dom';
import QuestionForm from './QuestionForm'; // Adjust path as needed
import { useNavigate } from 'react-router-dom';

const QuestionFormPage = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const initialQuestion = location.state?.initialQuestion;

    const handleCancel = () => {
        navigate('/dashboard/questions');
    };


    return (
        <div>
            <QuestionForm 
                initialQuestion={initialQuestion}
                onCancel={handleCancel}
            />
        </div>
    );
};

export default QuestionFormPage;